export default function SocialShare() {
	jQuery(document).on('click', 'img[data-network]', function(e) {
		e.preventDefault()

		const href = e.currentTarget.parentElement.getAttribute('href')
		const network = e.currentTarget.getAttribute('data-network')

		window.open(
			href,
			'',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,' +
				'height=' + networkSizes[network].height +
				',width=' + networkSizes[network].width)
	})

	const networkSizes = {
		facebook: { width: 600, height: 300 },
		twitter: { width: 600, height: 254 },
		linkedin: { width: 600, height: 473 }
	}
}